import { render, staticRenderFns } from "./gameLibConf.vue?vue&type=template&id=48f0b143"
import script from "./gameLibConf.vue?vue&type=script&lang=js"
export * from "./gameLibConf.vue?vue&type=script&lang=js"
import style0 from "./gameLibConf.vue?vue&type=style&index=0&id=48f0b143&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports